export default __webpack_public_path__ + "static/media/thai_iced_tea_thumbnail.97b6285b.JPG";